import dynamic from 'next/dynamic';

import type { ComponentsComparison } from 'queries/graphql';

import { useTextFontOverrides, useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import ComparisonTable from './components/ComparisonTable';

const MarkdownText = dynamic(() => import('generic/MarkdownText'));

import styles from './styles.module.scss';

export default function Comparison({
  sectionId,
  tables,
  title,
  text,
  style,
}: ComponentsComparison) {
  const { headingColor, textColor, headingFont, textFont, tableStyle } = style || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);
  const textFontOverrides = useTextFontOverrides(textFont);

  return (
    <div id={sectionId} className={`root ${styles.container} comparison`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--heading-color', headingColor, 'var(--heading-color-dark)')}
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${headingFontOverrides ?? ''}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      <div className={`${styles.comparison_wrapper} ${styles.sec_wrapper}`}>
        {title && <h1 className={styles.heading}>{title}</h1>}
        {text && <MarkdownText text={text} />}

        {tables.map(table => (
          <ComparisonTable key={table.id} {...table} tableStyle={tableStyle} />
        ))}
      </div>
    </div>
  );
}
